import React from "react";

const cardStyle = {
  display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
  padding: "22px 14px", background: "#fff", borderRadius: 10,
  boxShadow: "0 1px 3px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9",
  textDecoration: "none", color: "#334155",
  transition: "box-shadow 0.15s, transform 0.15s",
  textAlign: "center",
};

export function MenuCard({ label, icon, color, bg, href, desc, enabled = true }) {
  return (
    <div className="col-6 col-md-4 col-xl-3 mb-3">
      <a
        href={enabled ? href : undefined}
        style={{ ...cardStyle, opacity: enabled ? 1 : 0.45, pointerEvents: enabled ? "auto" : "none", cursor: enabled ? "pointer" : "default" }}
        onMouseEnter={(e) => { if (!enabled) return; e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
        onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.07)"; e.currentTarget.style.transform = "translateY(0)"; }}
      >
        <div style={{ width: 52, height: 52, borderRadius: 12, background: bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <i className={icon} style={{ color, fontSize: "1.35rem" }} />
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: "0.82rem", marginBottom: 2 }}>{label}</div>
          <div style={{ fontSize: "0.7rem", color: "#94a3b8", lineHeight: 1.3 }}>{desc}</div>
        </div>
      </a>
    </div>
  );
}

export function MenuSection({ title }) {
  return (
    <div className="col-12" style={{ marginTop: 20, marginBottom: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
        <span style={{ fontSize: "0.68rem", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", whiteSpace: "nowrap" }}>{title}</span>
        <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
      </div>
    </div>
  );
}

export function MenuHeader({ icon, color, bg, title, subtitle }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
      <div style={{ width: 36, height: 36, borderRadius: 8, background: bg, display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid ${color}40` }}>
        <i className={icon} style={{ color, fontSize: "1rem" }} />
      </div>
      <div>
        <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>{title}</h3>
        <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>{subtitle}</p>
      </div>
    </div>
  );
}
